<ion-content class="paywall-content ion-padding">
  <ion-header class="paywall-header ion-no-border">
    <ion-title>
      <h2>Welcome to {{ appConfig.appName }}</h2>
      <h3>Choose your plan and unlock more boards, sounds and features.</h3>
    </ion-title>
  </ion-header>

  <ion-item class="video-row">
    <ion-label class="text-wrap">Preview product demos and workflows.</ion-label>
    <ion-button size="small" (click)="showVideo()">Demonstration Videos</ion-button>
  </ion-item>

  <ion-item class="video-row" *ngIf="access48Illigible()">
    <ion-label class="text-wrap">
      Free trial is active for the initial install period.
    </ion-label>
  </ion-item>

  <!--
  <ion-item class="video-row">
    <ion-label class="text-wrap">Watch a video ad for temporary unlock {{ freeAdTime }}.</ion-label>
    <ion-button size="small" *ngIf="!loadingAd" (click)="videoAd()">Watch Ad</ion-button>
    <ion-spinner *ngIf="loadingAd" name="lines-sharp"></ion-spinner>
  </ion-item>
  -->

  <div class="tier-list">
    <ion-card
      class="tier-card"
      *ngFor="let tier of tiers"
      [class.selected]="selectedTierId === tier.id"
      (click)="selectTier(tier.id)"
    >
      <ion-card-header>
        <div class="tier-head">
          <div>
            <ion-card-title>{{ tier.title }}</ion-card-title>
            <ion-card-subtitle>{{ tier.subtitle }}</ion-card-subtitle>
          </div>
          <ion-chip [color]="tier.hasAds ? 'warning' : 'success'">
            <ion-label>{{ tier.hasAds ? 'Ads On' : 'ad-free experience' }}</ion-label>
          </ion-chip>
        </div>
      </ion-card-header>

      <ion-card-content>
        <div class="section-block">
          <div class="section-title">Boards</div>
          <ion-chip *ngFor="let item of visibleItems(tier, 'boards')"><ion-label>{{ item }}</ion-label></ion-chip>
          <ion-button
            fill="clear"
            size="small"
            *ngIf="tier.boards.length > previewCount"
            (click)="$event.stopPropagation(); toggleExpanded(tier.id, 'boards')"
          >
            {{ isExpanded(tier.id, 'boards') ? 'Show less' : 'Show more' }}
          </ion-button>
        </div>

        <div class="section-block">
          <div class="section-title">Instruments</div>
          <ion-chip *ngFor="let item of visibleItems(tier, 'instruments')"><ion-label>{{ item }}</ion-label></ion-chip>
          <ion-button
            fill="clear"
            size="small"
            *ngIf="tier.instruments.length > previewCount"
            (click)="$event.stopPropagation(); toggleExpanded(tier.id, 'instruments')"
          >
            {{ isExpanded(tier.id, 'instruments') ? 'Show less' : 'Show more' }}
          </ion-button>
        </div>

        <div class="section-block">
          <div class="section-title">Features</div>
          <ion-chip *ngFor="let item of visibleItems(tier, 'features')"><ion-label>{{ item }}</ion-label></ion-chip>
          <ion-button
            fill="clear"
            size="small"
            *ngIf="tier.features.length > previewCount"
            (click)="$event.stopPropagation(); toggleExpanded(tier.id, 'features')"
          >
            {{ isExpanded(tier.id, 'features') ? 'Show less' : 'Show more' }}
          </ion-button>
        </div>

        <div class="plan-row">
          <ion-chip
            *ngFor="let plan of tier.plans"
            [outline]="getSelectedPlan(tier.id) !== plan.id"
            color="primary"
            (click)="$event.stopPropagation(); selectPlan(tier.id, plan.id)"
          >
            <ion-label>{{ plan.label }}</ion-label>
          </ion-chip>
        </div>

        <div class="plan-note" *ngIf="tier.plans.length > 0">
          {{ getSelectedPlanNote(tier) }}
        </div>

        <ion-button
          expand="block"
          [disabled]="tier.id === 'free' || tier.comingSoon"
          (click)="$event.stopPropagation(); subscriptionFor(tier.id, getSelectedPlan(tier.id))"
        >
          {{ tier.id === 'free' ? 'Current Plan' : (tier.comingSoon ? 'Coming Soon' : 'Choose ' + tier.title) }}
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>

  <ion-toolbar class="paywall-actions">
    <ion-button color="light" *ngIf="access48Illigible()" (click)="freeaccess()">Free Access</ion-button>
    <ion-button color="primary" (click)="subscription()">Continue with Selected Plan</ion-button>
    <ion-button color="medium" (click)="navHome()">Home</ion-button>
    <ion-button color="danger" (click)="exitApp()">Exit</ion-button>
  </ion-toolbar>
</ion-content>
